import React, { Fragment,useEffect, useCallback } from 'react';
import { Link, useParams } from 'react-router-dom'
import Header from '../../components/header/Header';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Footer from '../../components/footer/Footer';
import { useForm } from "react-hook-form"
import { Button } from 'reactstrap';

// import useRazorpay from 'react-razorpay';

const UpgradePay = (props) => {
    const { appid } = useParams();
      const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
    } = useForm()

    // const Razorpay = useRazorpay();

    // const pack = JSON.parse(localStorage.getItem('package'));
    
    const [data, setData] = React.useState([]);

    const pack = JSON.parse(localStorage.getItem('package'));
    const [price, setPrice] = React.useState(pack.pack_price);
    const [gst, setGst] = React.useState(price * 0.18);
    const [total, setTotal] = React.useState(pack.pack_price);
    
    // const [pack, setPack] = React.useState({});
    // const [price, setPrice] = React.useState(0);
    // const [gst, setGst] = React.useState(0);
    // const [total, setTotal] = React.useState(0);

    const createOrder = async (data) => {
        // console.log(data);
        let response = await fetch('https://api.easemyhotel.io/api/renew/order_create', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                appid: appid,
                amount: total,
                package_id: pack.pack_id,
                package_type: data.type, 
                package_price: price,
                package_gst: gst,
                package_total: total + gst,
            }),
        });
        
        let res = await response.json()
        return res;
    }

    const onSubmit = async (data) => {

            let ord = await createOrder(data);
            // console.log(ord);
            // return;
            let options = {
                key: 'rzp_live_S8xTnIeQVAFO4z', // Enter the Key ID generated from the Dashboard
                amount: total + gst, // Amount is in currency subunits. Default currency is INR.
                currency: 'INR',
                name: 'EaseMyHotel',
                description: 'Package Payment',
                order_id: ord.order_id, //This is a sample Order ID. Pass the `order_id` obtained in the response of Step 1
                handler: function (response) {
                    // Handle the payment success response
                    console.log(response);
                    fetch('https://api.easemyhotel.io/api/pay/verify', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                        },
                        body: JSON.stringify({
                            razorpay_payment_id: response.razorpay_payment_id,
                            razorpay_order_id: response.razorpay_order_id,
                            razorpay_signature: response.razorpay_signature,
                            package_id: pack.pack_id,
                        }),
                    })
                    .then(res => res.json())
                    .then(resData => {
                        if(resData.code == 200) {
                            window.location.href = '/success';
                        } 
                    })
                    .catch(err => console.error('Verification Error:', err));
                },
                prefill: {
                    name: data.name,
                    email: data.email,
                    contact: data.phone,
                },
                theme: {
                    color: '#3399cc',
                },
            };
            if(ord.code == 200) {
            const rzpay = new window.Razorpay(options);
            rzpay.open();
            }
    
    }

 
    const getUserInfo = (appid) => {
        fetch(`https://api.easemyhotel.io/api/userinfo`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "appid": appid
                })
        })
        .then(response => response.json())
        .then(data => {
            if (data.code === 200) {
               setData(data.data);

            //    setPack(data.pack);
            //     setPrice(data.pack.pack_price);
            //     let gstAmount = data.pack.pack_price * 0.18;
            //     setGst(gstAmount);
            //     setTotal(data.pack.pack_price);
            }
        })
        .catch(error => {
            console.error('Error:', error);
        });
    }

    useEffect(() => {
        // Dynamically add Razorpay script
        const script = document.createElement('script');
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);
        
        getUserInfo(appid);
        
        return () => {
            document.body.removeChild(script);
        };

    }, [appid]);
    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                <section className="intro_about_section section_space">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12 text-center">
                                    <h1>Plan Upgrade </h1>
                                </div>
                            </div>
                        </div>
                </section>
                <section className="privacy_policy_section section_space pt-0">
                    <div className="container">
                    <form className="checkout_form_field row" onSubmit={handleSubmit(onSubmit)}>    
                        <div className="row">
                            <div className="col-lg-6">
                                <div className="checkout_form_div">
                                    <h5 style={{color:'#9769FF'}}>Billing Details</h5>
                                    <p className='mb-0'><span className='text-dark'>Name :</span> {data.hotel_name}</p>
                                    <p className='mb-0'><span className='text-dark'>Email :</span> {data.email}</p>
                                    <p className='mb-1'><span className='text-dark'>Contact No. :</span> {data.phone}</p>

                                    <p className='mb-0'><span className='text-dark'>Address :</span> {data.address}</p>
                                    <p className='mb-3'> {data.city}, {data.state}, {data.country}</p>


                                </div>
                            </div>
                                    

                            <div className="col-lg-5 offset-1">
                                <div className='checkout_form_inside checkout_form'>
                                    <h3 style={{marginBottom:"20px"}}>Order Summary</h3>
                                    <div className='row' style={{marginBottom:"10px"}}>
                                        <div className='col-md-8'> 
                                            <span>Package - {pack?.pack_title}</span>
                                            &nbsp;&nbsp;&nbsp;
                                            <select className='form-select' name='type' 
                                                {...register("type", { required: true })}
                                            style={{width:"auto", fontSize:14, display:"inline-block", border:"1px solid #ccc", padding:"5px 15px"}}
                                                onChange={(e) => {
                                                    if (e.target.value === "1") {
                                                        setPrice(pack?.pack_price);
                                                        let gst = pack?.pack_price * 0.18;
                                                        setGst(gst);    
                                                        setTotal(pack?.pack_price);
                                                    } else {
                                                        setPrice(pack.sell_price);
                                                        let total = pack?.sell_price * 12;
                                                        let gst = total * 0.18;
                                                        setGst(gst);
                                                        setTotal(total);
                                                    }
                                                }}
                                            >
                                                <option value="1">Monthly</option>
                                                <option value="2">Yearly</option>
                                            </select>
                                            {/* <span>₹{pack.sell_price}</span>
                                            <small>(per month)</small> */}
                                        </div>
                                        <div className='col-md-4 text-right'>
                                            {price == pack?.sell_price && <><strike style={{fontSize:13, color:"red"}}>₹{pack?.pack_price}</strike><br /></>}
                                            <span>₹</span><span>{price}</span>
                                        </div>
                                    </div>  
                                    {/* <div className='row' style={{marginBottom:"10px"}}>
                                        <div className='col-md-6'>
                                            <span>{pack.pack_title}</span>
                                        </div>
                                        <div className='col-md-6 text-right'>
                                            <span>₹</span><span>2000</span>
                                        </div>
                                    </div> */}

                                    <div className='row' style={{marginBottom:"10px"}}>
                                        <div className='col-md-6'>
                                            <span>Subtotal</span>
                                        </div>
                                        <div className='col-md-6 text-right'>
                                            <span>₹</span><span>{total}</span>
                                        </div>
                                    </div>
                                    <div className='row' style={{marginBottom:"10px"}}>
                                        <div className='col-md-6'>
                                            <span>GST</span>
                                        </div>
                                        <div className='col-md-6 text-right'>
                                            <span>₹</span><span>{gst}</span>
                                        </div>
                                    </div>
                                    <div className='row' style={{borderTop: "1px solid #ddd"}}>
                                        <div className='col-md-6'>
                                            <h4>Total</h4>
                                        </div>
                                        <div className='col-md-6 text-right'>
                                            <h4>₹{total+gst}</h4>
                                        </div>
                                    </div>
                                    <div className='row' style={{borderTop: "1px solid #ddd"}}>
                                        <div className='col-md-12'>
                                           <button type='submit' className='btn btn-outline-light try_free_btn' style={{width:'100%', padding:15, textAlign:"center"}}>Proceed to payment</button>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </form>
                    </div>
                </section>
               
            </main>
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};

export default UpgradePay;